export default __webpack_public_path__ + "static/media/x_icon.92d8c2ab.png";